import { render, staticRenderFns } from "./faceSheet.vue?vue&type=template&id=f025c98e&scoped=true"
import script from "./faceSheet.vue?vue&type=script&lang=js"
export * from "./faceSheet.vue?vue&type=script&lang=js"
import style0 from "./faceSheet.vue?vue&type=style&index=0&id=f025c98e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f025c98e",
  null
  
)

export default component.exports